import React from "react";

function Input({
  id = "",
  name = "",
  type = "",
  className = "",
  value = "",
  disabled = false,
  onChange,
  minLength,
  maxLength,
  checked = false,
  placeHolder = "",
  multiple = false,
  accept,
  readOnly = false,
}) {
  const handleOnChange = (e) => {
    if (onChange) onChange(e);
  };

  return (
    <input
      id={id}
      name={name}
      type={type}
      className={className || "form-control"}
      value={value}
      onChange={handleOnChange}
      minLength={minLength}
      maxLength={maxLength}
      disabled={disabled}
      checked={checked}
      placeholder={placeHolder}
      multiple={multiple}
      accept={accept}
      readOnly={readOnly}
    />
  );
}

export default Input;
